import React from "react";
import { connect, DispatchProp } from "react-redux";
import IAction from "../../../models/IAction";
import IStore from "../../../models/IStore";
import ContenutoAction from "stores/contenuto/ContenutoAction";
import { Container, Row, Col } from "react-bootstrap";
import LoadingIndicator from "views/components/loading-indicator/LoadingIndicator";
import { selectRequesting } from "selectors/requesting/RequestingSelector";
import ContenutoModel from "stores/contenuto/models/ContenutoModel";
import BaseSection from "./BaseSection";
import BaseSubsection from "./BaseSubsection";
import SezioneModel from "stores/contenuto/models/SezioneModel";
import SottosezioneModel from "stores/contenuto/models/SottosezioneModel";
import NavigationUtility from "utilities/NavigationUtility";

interface IProps {
    contentCode: string;
    positionId?: number;
}
interface IState {
    intestazione: SottosezioneModel | undefined;
    sezioni: SezioneModel[] | undefined;
}
interface IStateToProps {
    readonly isRequesting: boolean;
}

const mapStateToProps = (state: IStore): IStateToProps => ({
    isRequesting: selectRequesting(state, [ContenutoAction.REQUEST_CONTENUTO_GET]),
});

class BaseContent extends React.Component<IProps & IStateToProps & DispatchProp<IAction<any>>, IState> {
    constructor(props: IProps & IStateToProps & DispatchProp<IAction<any>>) {
        super(props);
        this.state = {
            intestazione: undefined,
            sezioni: undefined,
        } as IState;
    }

    private hasUnmounted = false;

    public componentDidMount(): void {
        this.setLookupsAndViewModel();
    }

    public componentWillUnmount() {
        this.hasUnmounted = true;
    }

    private setLookupsAndViewModel = async () => {
        let contenuto: ContenutoModel = await this.props.dispatch(ContenutoAction.contenutoGet(this.props.contentCode));
        let intestazione: SottosezioneModel | undefined = undefined;
        let sezioni: SezioneModel[] | undefined = undefined;
        if (contenuto && contenuto.sezioni && contenuto.sezioni.length > 0) {
            if (contenuto.sezioni.filter((x) => x.isIntestazione === true).length > 0) {
                let header = contenuto.sezioni.find((x) => x.isIntestazione === true);
                if (header) {
                    intestazione =
                        header.sottosezioni && header.sottosezioni.length > 0 ? header.sottosezioni[0] : undefined;
                }
            }
            sezioni = contenuto.sezioni.filter((x) => x.isIntestazione === false);
        }

        if (this.hasUnmounted === false) {
            this.setState({
                intestazione: intestazione,
                sezioni: sezioni,
            });
        }

        if (this.props.positionId) {
            const elem = document.getElementById("content-element-" + this.props.positionId);
            if (elem) {
                elem.scrollIntoView();
            }
        }
    };

    private redirectToPage = (page: string) => {
        NavigationUtility.redirectToPage(page);
    };

    public render(): JSX.Element {
        const { isRequesting } = this.props;
        const { intestazione, sezioni } = this.state;

        return (
            <LoadingIndicator isActive={isRequesting}>
                {intestazione ? (
                    <div className="bg-gradient-yellow">
                        <Container fluid="xl">
                            <Row>
                                <Col md={12}>
                                    <div className="m-4">
                                        <BaseSubsection
                                            subsection={intestazione}
                                            redirectToPage={this.redirectToPage}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                ) : null}
                {sezioni ? (
                    <Container fluid="xl">
                        {intestazione ? <hr className="mt-0"></hr> : null}
                        {sezioni.map((section, keysection) => (
                            <BaseSection
                                key={keysection}
                                section={section}
                                showDivider={sezioni.length > keysection + 1}
                                redirectToPage={this.redirectToPage}
                            />
                        ))}
                    </Container>
                ) : null}
            </LoadingIndicator>
        );
    }
}

export { BaseContent as Unconnected };
export default connect(mapStateToProps)(BaseContent);
